import React, { useRef } from 'react';
import { Image, Carousel } from 'antd';
import ICArrows from '../../assets/images/arrows.png';
import ICZoom from '../../assets/images/ic-zoom-img.png';
import ICPDF from '../../assets/images/ic-pdf.png';
import ICDownload from '../../assets/images/ic-dowload.png';

const ViewImageAndFile = (props) => {
    const carouselRef = useRef();
    const next = () => carouselRef.current.next();
    const prev = () => carouselRef.current.prev();
    return (
        <div style={{ display: 'flex' }}>
            <div style={{ position: 'relative', background: '#F0F2F5', borderRadius: 6, width: 252, height: 200, textAlign: 'center', gap: 5, padding: 5, marginRight: 10 }}>
                <Carousel arrows={false} ref={carouselRef} dots={true} >
                    {
                        (props?.listImage || []).map((item) => (
                            <div style={{ borderRadius: 12 }}>
                                <Image
                                    width={242}
                                    height={173}
                                    style={{ borderRadius: 12, objectFit: 'cover' }}
                                    src={item}
                                />
                            </div>
                        ))
                    }

                </Carousel>
                <div style={{ fontSize: 10 }}>
                    {props?.title || "Hình ảnh"}
                </div>
                <img onClick={prev} src={ICArrows} style={{
                    position: 'absolute',
                    top: '40%',
                    left: 10,
                    width: 22,
                    color: '#333',
                    cursor: 'pointer',
                    rotate: "180deg"
                }} />
                <img onClick={next} src={ICArrows} style={{
                    position: 'absolute',
                    top: '40%',
                    right: 10,
                    width: 22,
                    color: '#333',
                    cursor: 'pointer',
                }} />
                {/* <img src={ICZoom} style={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    width: 22,
                    color: '#333',
                    cursor: 'pointer',
                }} /> */}
            </div>
            {/* {
                props?.listFile?.length > 0 &&
                <div style={{ height: 200, marginTop: 20, width: '100%', overflow: 'auto' }}>
                    <div style={{ background: '#F0F2F5', display: 'flex', alignItems: 'center', gap: 5, justifyContent: 'space-between', padding: 5, borderRadius: 8, gap: 5, width: '100%', maxWidth: 252, marginBottom: 10, cursor: 'pointer' }}>
                        <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                            <img width={32} onClick={next} src={ICPDF} />
                            <div style={{ fontSize: 10 }}>
                                Tài liệu hoá đơn mua xe.pdf
                            </div>
                        </div>
                        <img width={14} onClick={next} src={ICDownload} />
                    </div>
                </div>
            } */}
        </div>
    )
};

export default ViewImageAndFile;